import React from 'react';
import Section from './Section';
import styled from 'styled-components';
import { connect } from 'react-redux';

const Header = styled.h1`
  padding-top: 10px;
  font-size: 1.4em;
`

const Content = ({ dispatch, poseLookup }) => (

      <div>

        <Section name="Down Dog & Plank" color="wheat" sectionIdentifier={0} poseIdentifiers={poseLookup[0]}/>

        <Section name="Standing" color="skyblue" sectionIdentifier={1} poseIdentifiers={poseLookup[1]}/>

        <Section name="Transition Moves" color="wheat" sectionIdentifier={2} poseIdentifiers={poseLookup[2]}/>

        <Section name="Squats" color="skyblue" sectionIdentifier={3} poseIdentifiers={poseLookup[3]}/>

        <Section name="Series 2 Sample Moves" color="wheat" sectionIdentifier={4} poseIdentifiers={poseLookup[4]}/>

        <Section name="Single Combo Moves" color="skyblue" sectionIdentifier={5} poseIdentifiers={poseLookup[5]}/>

        <Section name="Double Combo Moves" color="wheat" sectionIdentifier={6} poseIdentifiers={poseLookup[6]}/>

        <Section name="All Fours Moves" color="skyblue" sectionIdentifier={7} poseIdentifiers={poseLookup[7]}/>

        <Section name="Abs Moves Seated" color="wheat" sectionIdentifier={8} poseIdentifiers={poseLookup[8]}/>

        <Section name="Abs Moves Side Hip" color="skyblue" sectionIdentifier={9} poseIdentifiers={poseLookup[9]}/>

        <Section name="Abs Moves Reclined" color="wheat" sectionIdentifier={10} poseIdentifiers={poseLookup[10]}/>

      </div>

)

export default connect()(Content);



// WEBPACK FOOTER //
// ./src/Content.js